import _ from 'lodash'

import config from '@config'

import {
    LOAD_ASSIGNED_TENDERS_TABLE_DATA,
    LOAD_ASSIGNED_TENDERS_TABLE_DATA_REQUEST,
    ASSIGNED_TENDERS_TABLE_LOADING_TRUE,
    ASSIGNED_TENDERS_TABLE_LOADING_FALSE,
    ASSIGNED_TENDERS_TABLE_LOADING_FAILED,
    ASSIGNED_TENDERS_TABLE_DATA_RECEIVED,
} from './constants'

export const loadTableData = (module, block, entId, level, changeData = null) => ({
    type: LOAD_ASSIGNED_TENDERS_TABLE_DATA,
    data: {
        module,
        block,
        entId,
        level,
        changeData,
    },
})

export const loadTableDataRequest = (module, block, entId, level, lang, token, queryParams) => ({
    type: LOAD_ASSIGNED_TENDERS_TABLE_DATA_REQUEST(entId),
    payload: {
        uri: _.get(config, `api.${module}.${block}.tables.publishedTenders.uri`),
        qs: {
            ...queryParams,
            entId,
            lang,
            token,
            level,
            procurementType: 'pub',
        },
        uriParams: {
            entId,
            lang,
        },
        headers: {
            'X-Token': token,
        },
    },
})

export const tableDataReceived = (module, block, entId, data) => ({
    type: ASSIGNED_TENDERS_TABLE_DATA_RECEIVED,
    data: {
        module,
        block,
        entId,
        data,
    },
})

export const tableLoadingTrue = (module, block, entId, data) => ({
    type: ASSIGNED_TENDERS_TABLE_LOADING_TRUE,
    data: {
        module,
        block,
        entId,
        data,
    },
})

export const tableLoadingFalse = (module, block, entId, data) => ({
    type: ASSIGNED_TENDERS_TABLE_LOADING_FALSE,
    data: {
        module,
        block,
        entId,
        data,
    },
})

export const tableLoadingFailed = (module, block, entId, data) => ({
    type: ASSIGNED_TENDERS_TABLE_LOADING_FAILED,
    data: {
        module,
        block,
        entId,
        data,
    },
})
